import React from "react";
import ProductPanel from "../product-panel";
import ProductTabs from "./product-tabs";

import ProductSelectContainer from "../../layout/page/forms-container/form-item-container/product-select-container";
import "./styles.scss";
import { Product } from "../../../context/product-context/product";
import { ProductRefType } from "../../../context/product-context/types";

const classNameBase = "scd-product-selection";

export default function ProductSelection({
  selectedProduct,
  onSelectCallback,
}: {
  selectedProduct: Product;
  onSelectCallback?: (value: ProductRefType) => void;
}): React.JSX.Element {
  const handleProductChange = (
    _: React.SyntheticEvent,
    newProduct: Product,
  ) => {
    if (onSelectCallback) {
      onSelectCallback(newProduct.productRef);
    }
  };

  return (
    <ProductSelectContainer>
      <div className={`${classNameBase}-container`}>
        <ProductTabs
          selectedProduct={selectedProduct}
          onProductChange={handleProductChange}
        />
        <ProductPanel selectedProduct={selectedProduct} />
      </div>
    </ProductSelectContainer>
  );
}
